/**
 * State center coordinates for map navigation
 * Simple mapping of US state names to their approximate centroids
 */
export interface StateCenter {
  lat: number;
  lng: number;
  name: string;
}

export const stateCenters: Record<string, StateCenter> = {
  'Alabama': { lat: 32.806671, lng: -86.791130, name: 'Alabama' },
  'Alaska': { lat: 61.370716, lng: -152.404419, name: 'Alaska' },
  'Arizona': { lat: 33.729759, lng: -111.431221, name: 'Arizona' },
  'Arkansas': { lat: 34.969704, lng: -92.373123, name: 'Arkansas' },
  'California': { lat: 36.116203, lng: -119.681564, name: 'California' },
  'Colorado': { lat: 39.059811, lng: -105.311104, name: 'Colorado' },
  'Connecticut': { lat: 41.597782, lng: -72.755371, name: 'Connecticut' },
  'Delaware': { lat: 39.318523, lng: -75.507141, name: 'Delaware' },
  'Florida': { lat: 27.766279, lng: -82.640371, name: 'Florida' },
  'Georgia': { lat: 33.040619, lng: -83.643074, name: 'Georgia' },
  'Hawaii': { lat: 21.094318, lng: -157.498337, name: 'Hawaii' },
  'Idaho': { lat: 44.240459, lng: -114.478828, name: 'Idaho' },
  'Illinois': { lat: 40.349457, lng: -88.986137, name: 'Illinois' },
  'Indiana': { lat: 39.849426, lng: -86.258278, name: 'Indiana' },
  'Iowa': { lat: 42.011539, lng: -93.210526, name: 'Iowa' },
  'Kansas': { lat: 38.526600, lng: -96.726486, name: 'Kansas' },
  'Kentucky': { lat: 37.668140, lng: -84.670067, name: 'Kentucky' },
  'Louisiana': { lat: 31.169546, lng: -91.867805, name: 'Louisiana' },
  'Maine': { lat: 44.323535, lng: -69.765261, name: 'Maine' },
  'Maryland': { lat: 39.063946, lng: -76.802101, name: 'Maryland' },
  'Massachusetts': { lat: 42.235227, lng: -71.530106, name: 'Massachusetts' },
  'Michigan': { lat: 43.326618, lng: -84.536095, name: 'Michigan' },
  'Minnesota': { lat: 45.694454, lng: -93.900192, name: 'Minnesota' },
  'Mississippi': { lat: 32.741646, lng: -89.678696, name: 'Mississippi' },
  'Missouri': { lat: 38.572954, lng: -92.189283, name: 'Missouri' },
  'Montana': { lat: 46.921925, lng: -110.454353, name: 'Montana' },
  'Nebraska': { lat: 41.125370, lng: -98.268082, name: 'Nebraska' },
  'Nevada': { lat: 38.313515, lng: -117.055374, name: 'Nevada' },
  'New Hampshire': { lat: 43.452492, lng: -71.563896, name: 'New Hampshire' },
  'New Jersey': { lat: 40.298904, lng: -74.521011, name: 'New Jersey' },
  'New Mexico': { lat: 34.840515, lng: -106.248482, name: 'New Mexico' },
  'New York': { lat: 42.165726, lng: -74.948051, name: 'New York' },
  'North Carolina': { lat: 35.630066, lng: -79.806419, name: 'North Carolina' },
  'North Dakota': { lat: 47.528912, lng: -99.784012, name: 'North Dakota' },
  'Ohio': { lat: 40.388783, lng: -82.764915, name: 'Ohio' },
  'Oklahoma': { lat: 35.565342, lng: -96.928917, name: 'Oklahoma' },
  'Oregon': { lat: 44.572021, lng: -122.070938, name: 'Oregon' },
  'Pennsylvania': { lat: 40.590752, lng: -77.209755, name: 'Pennsylvania' },
  'Rhode Island': { lat: 41.680893, lng: -71.51178, name: 'Rhode Island' },
  'South Carolina': { lat: 33.856892, lng: -80.945007, name: 'South Carolina' },
  'South Dakota': { lat: 44.299782, lng: -99.438828, name: 'South Dakota' },
  'Tennessee': { lat: 35.747845, lng: -86.692345, name: 'Tennessee' },
  'Texas': { lat: 31.054487, lng: -97.563461, name: 'Texas' },
  'Utah': { lat: 40.150032, lng: -111.862434, name: 'Utah' },
  'Vermont': { lat: 44.045876, lng: -72.710686, name: 'Vermont' },
  'Virginia': { lat: 37.769337, lng: -78.169968, name: 'Virginia' },
  'Washington': { lat: 47.400902, lng: -121.490494, name: 'Washington' },
  'West Virginia': { lat: 38.491226, lng: -80.954453, name: 'West Virginia' },
  'Wisconsin': { lat: 44.268543, lng: -89.616508, name: 'Wisconsin' },
  'Wyoming': { lat: 42.755966, lng: -107.302490, name: 'Wyoming' },
};

/**
 * Get state center coordinates by name
 */
export function getStateCenter(stateName: string): StateCenter | null {
  return stateCenters[stateName] || null;
}

/**
 * Search states by name (case-insensitive)
 */
export function searchStates(query: string): StateCenter[] {
  const normalizedQuery = query.toLowerCase().trim();
  if (!normalizedQuery) return [];
  
  return Object.values(stateCenters)
    .filter(state => 
      state.name.toLowerCase().includes(normalizedQuery)
    )
    .slice(0, 5); // Limit to 5 results
}

